<!-- eslint-disable max-lines -->
<!-- eslint-disable max-lines-per-function -->
<template>
    <div class="submissionApplication-detail-Wrap" v-loading="loading">

        <div class="fixedBox">
            <div class="title">
                目标提报流程
                <span
                    class="status"
                    :class="{
                        'draft': ruleForm.approvalStatus === 1,
                        'pending-approval': ruleForm.approvalStatus === 2,
                        'pproval-ing': ruleForm.approvalStatus === 3,
                        'approval-pass': ruleForm.approvalStatus === 4,
                        'approval-reject': ruleForm.approvalStatus === 5,
                        'withdraw': ruleForm.approvalStatus === 6,
                        'discard': ruleForm.approvalStatus === 7,
                    }"
                >
                    {{ changeKeyToValue(ruleForm.approvalStatus) }}
                </span>
            </div>
            <!-- 按钮显示：审批状态=草稿/驳回/撤回（保存、提交审批） -->
            <!-- "3": "审批中", "5": "审批驳回", "6": "撤回", "4": "审批通过", "7": "作废", "1": "草稿", "2": "待审批" -->
            <div class="btnBox" v-if="ruleForm.approvalStatus === 1 || ruleForm.approvalStatus === 5 || ruleForm.approvalStatus === 6">
                <el-button type="primary" @click="saveOpera('ruleForm')">保存</el-button>
                <el-button
                    type="primary"
                    v-if="ruleForm.id && !mipUrl"
                    @click="verityOpera"
                    v-has="authorityCode.verity"
                >提交审批</el-button>
            </div>
        </div>

        <div class="formBox">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="72px"
                class="ruleForm"
            >
                <el-collapse v-model="collapseActiveNames">
                    <el-collapse-item name="1" class="pd0">
                        <template slot="title"><label class="el-collapse-custom-title">基础信息</label></template>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="标题：" prop="applyTitle">
                                    <el-input v-model="ruleForm.applyTitle" placeholder="请输入标题"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="年份：" prop="applyYear">
                                    <el-date-picker
                                        type="year"
                                        format="yyyy"
                                        value-format="yyyy"
                                        placeholder="请选择年份"
                                        v-model="ruleForm.applyYear"
                                        :disabled="!!ruleForm.id"
                                        style="width: 100%;"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="部门：" prop="deptName">
                                    <lots-md-input
                                        :label="ruleForm.deptName"
                                        :config="deptOpt"
                                        :cascadeData="ruleForm"
                                        :disabled="!!ruleForm.id"
                                        readonly
                                        @change="handleDeptChange($event, deptOpt)"
                                    ></lots-md-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="目标类型：" prop="goalTypeCodes" label-width="92px">
                                    {{ ruleForm.goalTypeNames }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="分组：" prop="groupIds">
                                    <otpAdvanceMulti
                                        v-if="!ruleForm.id && ruleForm.goalTypeCodes"
                                        class="advance-input"
                                        :params="{
                                            ...groupOption,
                                            beforeRequest: (params) => {
                                                params.goalTypeCodeSet = ruleForm.goalTypeCodes;
                                                return params;
                                            },
                                        }"
                                        @getAdvanceValue="(data) => { getGroupInfo(data); }"
                                        :disabled="!!ruleForm.id"
                                        :mValue="ruleForm.groupName">
                                    </otpAdvanceMulti>
                                    <span v-else>{{ ruleForm.groupNames }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="备注：" prop="mark">
                                    <el-input type="textarea" rows="1" placeholder="请输入备注" v-model="ruleForm.mark"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="附件：" prop="fileList">
                                    <lots-upload-button
                                        :text="'上传附件'"
                                        :bucket="'annto-lcrm'"
                                        @beforeUpload="beforeUploadUrl"
                                        @callback="(data) => { upLoadFileUrl(data); }"
                                    ></lots-upload-button>

                                    <div class="file-infos">
                                        <div
                                            class="file-list"
                                            v-for="(item, index) in ruleForm.fileList"
                                            :key="index + item.fileName"
                                        >
                                            <div class="file-name upload" :title="item.fileName">
                                                {{ `${index + 1}. ` }}
                                                <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                            </div>
                                            <div class="delete-btn">
                                                <el-button type="text" plain @click="handlePreview(item)">
                                                    预览
                                                </el-button>
                                                <el-button type="text" plain>
                                                    <a :href="item.fileUrl" target="_blank">下载</a>
                                                </el-button>
                                                <el-button
                                                    type="text"
                                                    plain
                                                    v-if="ruleForm.approvalStatus === 1 || ruleForm.approvalStatus === 5 || ruleForm.approvalStatus === 6"
                                                    @click="delFile(item, index)"
                                                >
                                                    删除
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="upload-alert-item" v-for="(item, index) in ruleForm.fileList" :key="index">
                                        <span :title="item.fileName">{{ item.fileName }}</span>
                                        <i class="el-icon-circle-close" title="删除" @click="delFile(item, index)"></i>
                                    </div> -->
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="2">
                        <template slot="title"><label class="el-collapse-custom-title">系统信息</label></template>
                        <el-row>
                            <el-col :span="6"><label>填报单据号：</label><span>{{ ruleForm.applyCode || '--' }}</span></el-col>
                            <el-col :span="6"><label>单据类型：</label><span>{{ ruleForm.applyTypeName || '--' }}</span></el-col>
                            <el-col :span="6"><label>修改人：</label><span>{{ ruleForm.updateUserName || '--' }}</span></el-col>
                            <el-col :span="6"><label>修改时间：</label><span>{{ ruleForm.updateTime || '--' }}</span></el-col>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </el-form>

            <!-- 前提是创建完成 -->
            <template>
                <el-tabs ref="flowBoxRefs" class="flowBoxWrap" v-model="tabsActiveName">
                    <el-tab-pane label="目标明细" name="first"></el-tab-pane>
                    <el-tab-pane label="流程信息" name="second"></el-tab-pane>
                </el-tabs>

                <div class="targetWrap" v-show="tabsActiveName === 'first'">
                    <div class="left">
                        <targetObj ref="targetObj" :data="ruleForm" @updateCurrentRow="updateCurrentRow" />
                    </div>
                    <div class="right">
                        <targetDetail v-if="goalTypeOptions.length" ref="targetDetail" @deleteSuccessHandle="deleteSuccessHandle" :data="ruleForm" :goalTypeOptions="goalTypeOptions" />
                    </div>
                </div>

                <div class="header-operation" v-if="tabsActiveName === 'second'">
                    <lots-button
                        size="mini"
                        type="primary"
                        v-if="mipUrl && !['7'].includes(ruleForm.approvalStatus)"
                        @click="submitMip"
                    >mip提交</lots-button>
                </div>
                <iframe ref="mipIframe" class="ifr" :src="mipUrl" v-if="tabsActiveName === 'second' && mipUrl" />
            </template>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { saveApi, verityApi, detailApi, getGoalType, getGroupList, checkVerityApi } from '@/modules/mdm/api/targetModdeules/subMissionApplication.js';
import { Message } from 'element-ui';
import targetObj from '@/modules/mdm/views/targetModules/submissionApplication/components/targetObj.vue';
import targetDetail from '@/modules/mdm/views/targetModules/submissionApplication/components/targetDetail.vue';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import lotsMdInput from '@/components/lots/lotsMdInput';
import _ from 'lodash';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import configurl from '@/config/user.env';
import store from '@/store/index';
import lotsButton from '@/components/lots/lotsButton';
import { deptOption, groupOption } from '@/modules/mdm/views/targetModules/submissionApplication/option.js';
import otpAdvanceMulti from '@/components/lots/otpAdvanceMulti/index.vue';
import { filePreview } from '@/utils/filePreview.js';

export default {
    name: 'targetForm',
    components: {
        targetObj,
        targetDetail,
        lotsButton,
        lotsMdInput,
        lotsUploadButton,
        otpAdvanceMulti
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        dictDatas: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const loading = ref(false);
        const flowBoxRefs = ref(null);
        // 按钮权限
        const authorityCode = reactive(btnAuthority.submissionApplication);
        // 折叠面板
        const collapseActiveNames = ref(['1']);
        // 选项卡
        const tabsActiveName = ref('first');
        // 流程信息iframe地址
        const mipUrl = ref(null);

        // 保存操作
        const saveOpera = (formName) => {
            setupContext.refs[formName].validate((valid) => {
                if (valid) {
                    const params = _.cloneDeep(ruleForm);
                    if (params.fileList && params.fileList.length > 0) {
                        params.fileUrl = params.fileList.map(item => item.fileUrl).join(',');
                        params.fileName = params.fileList.map(item => item.fileName).join(',');
                    } else {
                        params.fileUrl = '';
                        params.fileName = '';
                    }
                    if (params.groupIds && params.groupIds.length > 0) {
                        params.groupIds = params.groupIds.map(item => item).join(',');
                    } else {
                        params.groupIds = '';
                    }
                    Reflect.deleteProperty(params, 'fileList');
                    loading.value = true;
                    saveApi(params).then(res => {
                        if (+res.code === 0) {
                            Message.success('保存成功');
                            // 立即设置ruleForm.id，确保提交审批按钮立即显示
                            ruleForm.id = res.data.id;
                            applyId.value = res.data.id;
                            // 刷新详情
                            const time = 1000;
                            // 等待time毫秒，确保后台更新完成
                            setTimeout(() => {
                                getDetail(res.data.id);
                                setupContext.emit('createSuccessHandle');
                            }, time);
                        }
                    }).finally(() => {
                        const time = 1000;
                        // 等待time毫秒，确保后台更新完成
                        setTimeout(() => {
                            loading.value = false;
                        }, time);
                    });
                } else {
                    return false;
                }
            });
        };

        const updateCurrentRow = (obj) => {
            setupContext.root.$nextTick(() => {
                setupContext.refs['targetDetail'].refreshList(obj.groupName, obj.groupId);
            });
        };

        const deleteSuccessHandle = () => {
            setupContext.root.$nextTick(() => {
                setupContext.refs['targetObj'].refreshList();
            });
            // getDetail(applyId.value);
        };

        // 申请单id
        const applyId = ref('');
        onMounted(() => {
            if (props.data) {
                // 单据类型编码
                ruleForm.applyType = props.data.applyType;
                // 申请单类型名称
                ruleForm.applyTypeName = props.data.applyTypeName;
                // 根据单据类型,查找目标类型下拉框：
                getGoalTypeList(props.data.applyType);
                // 重置表单
                setupContext.refs['ruleForm'] && setupContext.refs['ruleForm'].resetFields();
                // 有id，查询详情
                if (props.data.id) {
                    getDetail(props.data.id);
                }
            }
        });

        // 字典值转换为字典标签
        const changeKeyToValue = (v) => {
            return props.dictDatas['LCRM_MIP_STATUS']?.[v] ?? null;
        };

        // 部门选择器改变事件，设置部门名称和部门编码
        const handleDeptChange = (data) => {
            ruleForm.deptName = data.deptName;
            ruleForm.deptCode = data.deptCode;
        };

        const getGroupInfo = (data) => {
            const groupIds = [];
            const groupNames = [];
            if (data && data.length) {
                data.forEach(item => {
                    groupIds.push(item.groupIdSet);
                    groupNames.push(item.groupName);
                });
            }
            ruleForm.groupIds = groupIds;
            ruleForm.groupNames = groupNames.join(',');
        };

        // 上传文件前的回调函数
        const beforeUploadUrl = res => {};

        // 上传文件后的回调函数
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                ruleForm.fileList.push({
                    fileUrl: res.data.downUrl,
                    fileName: res.data.name
                });
                setupContext.refs['ruleForm'].clearValidate('fileList');
            }
        };

        // 删除文件
        const delFile = (item, index) => {
            ruleForm.fileList.splice(index, 1);
        };

        // 根据单据类型,查找目标类型数据
        const goalTypeOptions = ref([]);
        const getGoalTypeList = (type) => {
            loading.value = true;
            getGoalType({ applyType: type }).then(res => {
                if (+res.code === 0) {
                    // 将对象转换为key和value都是字符串的格式
                    const list = Object.entries(res.data).map(([key, value]) => ({
                        key: String(key),
                        value: String(value)
                    }));
                    // 目标类型下拉框选项
                    goalTypeOptions.value = list;
                    // 目标类型编码
                    ruleForm.goalTypeCodes = list.map(item => item.key).join(',');
                    // 目标类型名称
                    ruleForm.goalTypeNames = list.map(item => item.value).join(',');
                    // 根据目标类型, 查找分组下拉框：
                    getGroupListData(ruleForm.goalTypeCodes);
                }
            }).finally(() => {
                loading.value = false;
            });
        };

        // 根据目标类型,查找分组下拉框
        const groupList = ref([]);
        const getGroupListData = (code) => {
            getGroupList({ goalTypeCodeSet: code, pageSize: 200 }).then(res => {
                if (+res.code === 0) {
                    groupList.value = res.data.list || [];
                }
            });
        };

        // 表单数据
        const ruleForm = reactive({
            applyTitle: '',
            applyYear: '',
            deptName: '',
            mark: '',
            fileUrl: '',
            goalTypeCodes: '',
            goalTypeNames: '',
            groupIds: [],
            applyType: '',
            applyTypeName: '',
            approvalStatus: 1,
            fileList: [],
            isRefresh: 0 // 添加isRefresh属性
        });

        // 表单验证规则
        const rules = {
            applyTitle: [
                { required: true, message: '请输入标题', trigger: 'blur' }
            ],
            deptName: [
                { required: true, message: '请选择部门', trigger: 'change' }
            ],
            applyYear: [
                { required: true, message: '请选择年份', trigger: 'change' }
            ],
            groupIds: [
                { required: true, message: '请选择分组', trigger: 'change' }
            ]
        };

        // 部门选择器配置
        const deptOpt = reactive(deptOption);

        // 获取详情
        const getDetail = (id) => {
            return new Promise((resolve, reject) => {
                loading.value = true;
                detailApi({ id: id }).then(res => {
                    if (+res.code === 0) {
                        applyId.value = res.data.id;
                        const resData = res.data;
                        resData.isRefresh = new Date().getMilliseconds();
                        Object.assign(ruleForm, resData);
                        const { userName, userCode } = store.getters.user;
                        // 流程信息iframe地址
                        mipUrl.value = null;
                        if (res.data?.applyFlow?.mipId) {
                            setTimeout(() => {
                                mipUrl.value = `${configurl.iflowUrl}?fdId=${res.data?.applyFlow?.mipId}&fdTemplateKey=CRM_goal_apply_flow&userCode=${userCode}&userName=${userName}`;
                            }, 100);
                        }
                        // 附件回显
                        if (res.data.fileUrl) {
                            const fileList = [];
                            const fileUrl = res.data.fileUrl.split(',');
                            const fileName = res.data.fileName.split(',');
                            for (let i = 0; i < fileUrl.length; i++) {
                                fileList.push({
                                    fileUrl: fileUrl[i],
                                    fileName: fileName[i]
                                });
                            }
                            ruleForm.fileList = fileList;
                        }
                        // 分组数据回显
                        if (res.data.groupIds) {
                            ruleForm.groupIds = res.data.groupIds
                                .split(',')
                                .map(item => item.trim()) // 去除空格
                                .filter(item => item) // 过滤空字符串
                                .map(item => Number(item)) // 转换为数字
                                .filter(num => !isNaN(num)); // 过滤无效数字
                        }
                        resolve();
                    }
                }).finally(() => {
                    loading.value = false;
                });
            });
        };

        // 提交审批操作
        const verityOpera = () => {
            const params = {
                applyInfoCode: ruleForm.applyCode
            };
            loading.value = true;
            verityApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('提交审批成功');
                    // 刷新详情
                    const time = 1000;
                    // 等待time毫秒，确保后台更新完成
                    setTimeout(() => {
                        loading.value = false;
                        getDetail(applyId.value).then(res => {
                            // 切换到流程信息tab
                            tabsActiveName.value = 'second';
                            // 页面滚动到tabs位置
                            // eslint-disable-next-line max-nested-callbacks
                            setTimeout(() => {
                                flowBoxRefs.value && flowBoxRefs.value.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        });
                        setupContext.emit('createSuccessHandle');
                    }, time);
                }
            }).finally(() => {
                const time = 1000;
                // 等待time毫秒，确保后台更新完成
                setTimeout(() => {
                    loading.value = false;
                }, time);
            });
        };

        // eslint-disable-next-line complexity
        const submitMip = async () => {
            checkVerityApi({
                applyInfoCode: ruleForm.applyCode
            }).then(res => {
                if (+res.code === 0) {
                    setupContext.emit('mipSuccess', {
                        applyId: applyId.value,
                        mipId: ruleForm?.applyFlow?.mipId,
                        mipUrl: mipUrl.value
                    });
                }
            });
        };

        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };

        return {
            collapseActiveNames,
            tabsActiveName,
            ruleForm,
            groupList,
            saveOpera,
            verityOpera,
            rules,
            authorityCode,
            handleDeptChange,
            getGroupInfo,
            deptOpt,
            groupOption,
            beforeUploadUrl,
            upLoadFileUrl,
            delFile,
            loading,
            changeKeyToValue,
            goalTypeOptions,
            mipUrl,
            submitMip,
            updateCurrentRow,
            deleteSuccessHandle,
            getDetail,
            handlePreview
        };
    }
};
</script>

<style lang="less" scoped>
::v-deep .ruleForm {
    .el-tag.el-tag--info,
    .el-input.is-disabled .el-input__inner::placeholder,
    .el-input.is-disabled .el-input__inner {
        color: #606266;
    }
}
::v-deep .pd0 {
    .el-collapse-item__content {
        padding-bottom: 0;
    }
}
::v-deep .upload-alert-item {
    display: flex;
    padding: 0;
    align-items: center;

    span {
        color: #67c23a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        text-decoration: underline;
        font-size: 14px;
        max-width: 240px;
    }
    .el-icon-circle-close {
        color: #b1b3b0;
        font-size: 16px;
        margin-left: 8px;
        cursor: pointer;

        &:hover {
            background-color: #b1b3b0;
            color: #fff;
            border-radius: 1000px;
        }
    }
}
// ::v-deep .flowBoxWrap {
//     .el-tabs__item {
//         height: 32px;
//         line-height: 32px;
//     }
// }
.file-infos {
    width: 100%;
    padding: 0 10px 0 0;

    .file-list {
        width: 100%;
        padding: 2px 0 2px 4px;
        display: flex;

        // justify-content: space-between;
        .file-name {

            // flex: 1;
            &.upload {
                width: 500px;
            }

            padding-right: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
        }

        .view-btn,
        .delete-btn {
            width: 200px;
            display: flex;

            a {
                text-decoration: none;
                color: #4285F5;
            }

            .el-button {
                margin-left: 10px;
            }

            .el-button:focus,
            .el-button:hover,
            .el-button:active,
            .el-button.is-disabled {
                outline: none !important;
                border-color: transparent !important;
                /* 可选：如果要去除激活时的边框颜色变化 */
            }
        }
    }
}
.ifr {
    width: 100%;
    height: 100vh;
    border: none;
}
.el-collapse-custom-title {
    color: #606266;
    font-size: 14px;
    font-weight: 600;
}
.targetWrap {
    display: flex;
    flex-direction: row;
    .left {
        width: 32%;
        margin-right: 20px;
    }
    .right {
        width: 66%;
    }
}
.submissionApplication-detail-Wrap {
    display: flex;
    flex-direction: column;
    .fixedBox {
        height: 70px;
    }
    .formBox {
        height: calc(100vh - 238px);
        overflow-y: auto;
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        position: relative;
        text-align: center;

        .status {
            display: inline-block;
            background-color: #ccc;
            color: black;
            padding: 4px 8px;
            border-radius: 4px;
            margin-left: 10px;
            font-size: 14px;

            &.draft {
                background-color: #909399;
                color: #fff;
            }
            &.pending-approval {
                background-color: #409eff;
                color: #fff;
            }
            &.approval-ing {
                background-color: #e6a23c;
                color: #fff;
            }
            &.approval-pass {
                background-color: #67c23a;
                color: #fff;
            }
            &.approval-reject {
                background-color: #f56c6c;
                color: #fff;
            }
            &.withdraw {
                background-color: #c27809;
                color: #fff;
            }
            &.discard {
                background-color: #363635;
                color: #fff;
            }
        }

        .addNewAddr {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}
</style>
